import { Skeleton } from 'antd';
import React from 'react';

export function getEmptyPage() {
  return <Skeleton style={{ padding: '24px 36px' }} active paragraph={{ rows: 10 }} />;
}
